module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-print"
  }, [_c('section', {
    staticClass: "cover-page"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('h1', {
    staticClass: "report-title"
  }, [_vm._v(_vm._s(_vm.report.report_title))]), _vm._v(" "), _c('div', {
    staticClass: "report-date"
  }, [_vm._v(_vm._s(_vm.formattedDate))])]), _vm._v(" "), _c('img', {
    staticClass: "cover-page-graphic",
    attrs: {
      "src": "/static/cover_page.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "page preface-page",
    domProps: {
      "innerHTML": _vm._s(_vm.renderedPreface)
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "toc page"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Table of Contents")]), _vm._v(" "), _c('ul', _vm._l((_vm.sections), function(section, index) {
    return _c('li', [_vm._v("\n\t\t\t\t" + _vm._s(section.heading) + "\n\t\t\t\t"), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(index + 3))])])
  })), _vm._v(" "), _c('img', {
    staticClass: "footer-graphic",
    attrs: {
      "src": "/static/report_footer.png"
    }
  })]), _vm._v(" "), _vm._l((_vm.renderedSections), function(section, index) {
    return _c('div', [_c('section', {
      staticClass: "report-section page"
    }, [_vm._m(1, true), _vm._v(" "), _c('h2', [_vm._v(_vm._s(section.heading))]), _vm._v(" "), _c('div', {
      staticClass: "intro",
      domProps: {
        "innerHTML": _vm._s(section.description_text)
      }
    }), _vm._v(" "), (section.has_guidelines == '1') ? _c('div', [_c('h3', [_vm._v("Guidelines And Requirements")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(section.guidelines_text)
      }
    })]) : _vm._e(), _vm._v(" "), (section.has_findings == '1') ? _c('div', [_c('h3', [_vm._v("Findings")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(section.findings)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "page-num"
    }, [_vm._v(_vm._s(index + 3))]), _vm._v(" "), _c('img', {
      staticClass: "footer-graphic",
      attrs: {
        "src": "/static/report_footer.png"
      }
    })])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c14c4cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportViewer.vue
// module id = 299
// module chunks = 0